const mainState = {
  ruta: "/ActualizarArancel/FiltroBusqueda",
  // ruta: "/SolicitudesRealizadas/FiltroBusqueda",
  parametros: null,
  menuIsOpen: false,
  isLoading: 0,
};

export default mainState;
